"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_lot_status = void 0;
var api_1 = require("../../../api");
var update_lot_status = function (req) {
    return (0, api_1.apiPut)({
        endpoint: "v3/lot/update-lot-details",
        // data: formData,
        data: req,
    });
};
exports.update_lot_status = update_lot_status;
